import React from "react";
import { Box, Typography } from "@mui/material";
import BrandLogoImage from "../BrandLogoImage";

export default function NavbarBrand({
  businessName,
  homeLabel,
  logoUrl,
  compactLogoUrl,
  compact = false,
  surfaceStyle = null,
  maxLogoHeight = null,
  logoColor = "",
  textColor = "",
  onClick,
  fieldPath = "business.name",
}) {
  const source = compact ? compactLogoUrl || logoUrl : logoUrl;
  const label = String(businessName ?? homeLabel ?? "").trim();
  const accessibleLabel = String(homeLabel || businessName || "Inicio").trim();
  const requestedLogoHeight = maxLogoHeight === "" || maxLogoHeight === null || maxLogoHeight === undefined
    ? null
    : Number(maxLogoHeight);
  const explicitLogoHeight = Number.isFinite(requestedLogoHeight)
    ? Math.min(compact ? 96 : 120, Math.max(20, requestedLogoHeight))
    : null;

  if (!source && !label) return null;

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-label={accessibleLabel}
      sx={{
        border: 0,
        p: 0,
        bgcolor: "transparent",
        color: "inherit",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        minWidth: 0,
        maxWidth: compact ? { xs: "min(42vw, 150px)", sm: 190, lg: 250 } : { xs: 190, lg: 250 },
        transition: "transform .2s ease, opacity .2s ease",
        "&:hover": { transform: "translateY(-1px)", opacity: 0.92 },
        "&:focus-visible": {
          outline: "3px solid",
          outlineColor: "primary.main",
          outlineOffset: 4,
          borderRadius: 2,
        },
      }}
    >
      {source ? (
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            px: `${Number(surfaceStyle?.paddingX || 0)}px`,
            py: `${Number(surfaceStyle?.paddingY || 0)}px`,
            bgcolor: surfaceStyle?.backgroundColor || "transparent",
            border: "1px solid",
            borderColor: surfaceStyle?.borderColor || "transparent",
            borderRadius: `${Number(surfaceStyle?.borderRadius || 0)}px`,
            boxShadow: surfaceStyle?.boxShadow || "none",
          }}
        >
          <BrandLogoImage
            src={source}
            alt={label}
            logoColor={logoColor}
            sx={explicitLogoHeight !== null
              ? {
                  display: "block",
                  width: "auto",
                  maxWidth: "100%",
                  height: `${explicitLogoHeight}px`,
                  maxHeight: `${explicitLogoHeight}px`,
                  objectFit: "contain",
                }
              : {
                  display: "block",
                  width: compact ? { xs: "min(38vw, 136px)", sm: 164 } : { md: 190, lg: 220 },
                  height: compact ? { xs: 38, sm: 42 } : { md: 52, lg: 58 },
                  objectFit: "contain",
                  transform: "scale(var(--wp-segment-image-scale, 1))",
                  transformOrigin: "center",
                }}
          />
        </Box>
      ) : (
        <Typography
          data-landing-field={fieldPath || undefined}
          component="span"
          sx={{
            color: textColor || "#19242F",
            fontFamily: "inherit",
            fontSize: compact ? "var(--wp-navbar-title-mobile, 1.12rem)" : { md: "var(--wp-navbar-title-md, 1.25rem)", lg: "var(--wp-navbar-title-lg, 1.4rem)" },
            fontWeight: "var(--wp-segment-title-weight, 950)",
            letterSpacing: "var(--wp-segment-letter-spacing, -.035em)",
            lineHeight: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
